export const body = {
    paddingTop: "30px",
    height: "100%",
    overflow: "scroll"
};

export const topHeading = {
    textAlign: "center"
};

export const checkoutButton = {
    width: "100%"
};

export const mobile_topCheckoutInfo = {
    padding: "10px"
};

export const mobile_bottomCheckoutButton = {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    padding: "10px"
};
